import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

export function useInitIdioma(publicToken?) {

  const [t, i18n] = useTranslation("global");
  const history = useHistory()
  let idioma;
  try {
    idioma = localStorage.getItem('idioma');
  } catch (e) {
    if (publicToken) {
      history.push(`/${publicToken}/cookies`)
    }
  }

  if (idioma == null) {
    const userLang = window.navigator.language;
    idioma = userLang.substring(0, 2);
    if (!languages.find(value => value == idioma)) {
      idioma = 'en'
    }
  }

  const T = (value) => capitalize(t(value))
  
  return {idioma, t, i18n, T}
}
export const capitalize = (text: string): string =>
  text.charAt(0).toUpperCase() + text.slice(1)

const languages = ['es', 'en', 'fr', 'de', 'he']
export const Languages = {
  es: 'spanish',
  en: 'english',
  fr: 'french',
  de: 'germany',
  nl: 'netherlands',
  he: 'hebrew',
}
/*
export const initIdioma = (publicToken) => {
    i18n
      .use(initReactI18next)
      .init()

    let idioma;
    try {
        idioma = localStorage.getItem('idioma');
    } catch(e) {
        if(publicToken) {
            const history = createBrowserHistory()
            history.push(`/${publicToken}/cookies`)
        }
    }

    if(idioma == null){
        const userLang = window.navigator.language;
        idioma = userLang.substring(0,2);
    }
    return {idioma, t: i18n.t, i18n: i18n}
}*/
